import React from 'react';
import bottomWall from '../../../assets/images/game/card-shoe-1.png';
import backsideWall from '../../../assets/images/game/card-shoe-3.png';
import cardGroupHolder from '../../../assets/images/game/card-shoe-4.png';
import frontSideWall from '../../../assets/images/game/card-shoe-2.png';
import cardGroupSmallLeft from '../../../assets/images/game/cardGroupSmallLeft.png';
import cardGroupSmallRight from '../../../assets/images/game/cardGroupSmallRight.png';
import { CARD_IMG_MAX_WIDTH_BY_PX, CARD_IMG_MIN_WIDTH_BY_PX } from '../../../enums/cardStatus';

function CardHolderWebView({
  cardCut,
  cardBack,
  cuttingCardPlace,
  cuttingCardPosition,
  calculateCardGroupWidth,
}) {
  return (
    <div className='card-holder-c'>
      <div className='card-holder-bottom-wall'>
        <img src={bottomWall} alt='' />
      </div>
      <div className='card-holder-backside-wall'>
        <img src={backsideWall} alt='' />
      </div>
      <div
        className='card-group-container'
        style={{
          maxWidth: `${calculateCardGroupWidth(
            CARD_IMG_MIN_WIDTH_BY_PX,
            CARD_IMG_MAX_WIDTH_BY_PX
          )}px`,
        }}
      >
        {/* change max-width value from 176px to 244px */}
        <div className='card-group-wrapper'>
          <div className='inner-card-group-wrapper'>
            <img src={cardGroupSmallLeft} alt='' />
          </div>
          <div className='inner-card-group-wrapper'>
            <img src={cardGroupSmallRight} alt='' />
          </div>
        </div>
        <div className='card-group-holder'>
          <img src={cardGroupHolder} alt='' />
        </div>
        <span className='card-cuter-item' style={{ left: `${cuttingCardPosition}%` }} />
      </div>
      <div
        className={`card-holder-front-card ${cuttingCardPlace !== 0 ? '' : cardCut} ${cardBack}`}
      />
      <div className='card-holder-front-side-wall'>
        <img src={frontSideWall} alt='' />
      </div>
    </div>
  );
}

export default CardHolderWebView;
